import script from "./Btn.vue?vue&type=script&lang=ts&setup=true"
export * from "./Btn.vue?vue&type=script&lang=ts&setup=true"

import "./Btn.vue?vue&type=style&index=0&id=a6eeb12a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6eeb12a"]])

export default __exports__